import { z } from 'zod';
import { IsoInstantSchema } from './common.js';
import { LicenseClassSchema, RoleSchema } from './enums.js';
export const LoginRequestSchema = z.object({
    email: z.string().email().max(255),
    password: z.string().min(8).max(200),
});
export const RegisterRequestSchema = z.object({
    email: z.string().email().max(255),
    password: z.string().min(8).max(200),
    displayName: z.string().min(2).max(120),
});
export const UserResponseSchema = z.object({
    id: z.number().int().positive(),
    email: z.string().email(),
    displayName: z.string(),
    role: RoleSchema,
    pilotLicenseClass: LicenseClassSchema,
    createdAt: IsoInstantSchema,
});
export const AuthResponseSchema = z.object({
    accessToken: z.string(),
    expiresAt: IsoInstantSchema,
    user: UserResponseSchema,
});
export const UpdateUserRequestSchema = z.object({
    role: RoleSchema.optional(),
    pilotLicenseClass: LicenseClassSchema.optional(),
    displayName: z.string().min(2).max(120).optional(),
});
//# sourceMappingURL=auth.dto.js.map